import { dashboardT } from '../../../../lib/messages';
import { dashboardMetricLabelKey, formatDashboardMetric } from '../../format';
import type { DashboardMetric } from '../../model';
import {
  dashboardMetricValue,
  type DashboardMetricValues,
  type DashboardTimelinePoint,
  type DashboardWidgetAction,
} from '../../model';
import { DashboardWidgetActions } from '../DashboardWidgetActions';
import { DashboardMetricCardView } from './DashboardMetricCardView';

export interface DashboardMetricCardProps {
  metric: DashboardMetric;
  total?: DashboardMetricValues | null | undefined;
  previous?: DashboardMetricValues | null | undefined;
  comparisonPeriod?: string | null | undefined;
  timeline?: readonly DashboardTimelinePoint[] | undefined;
  loading: boolean;
  error: boolean;
  actions: readonly DashboardWidgetAction[];
}

export function DashboardMetricCard({
  metric,
  total,
  previous,
  comparisonPeriod,
  timeline = [],
  loading,
  error,
  actions,
}: DashboardMetricCardProps) {
  const currentValue = dashboardMetricValue(total, metric);
  const previousValue = dashboardMetricValue(previous, metric);

  const label = dashboardT(dashboardMetricLabelKey(metric));
  const timelineValues = timeline
    .map((point) => dashboardMetricValue(point, metric))
    .filter((value): value is number => value !== undefined);

  return (
    <DashboardMetricCardView
      label={label}
      value={formatDashboardMetric(currentValue, metric)}
      current={currentValue}
      previous={previousValue}
      comparisonPeriod={comparisonPeriod}
      timelineValues={timelineValues}
      loading={loading}
      error={error}
      footer={
        <DashboardWidgetActions actions={actions} className="border-border border-t px-3 py-2" />
      }
    />
  );
}
